import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  servicioList,
  servicioListSelectBox,
  servicioCreate,
  servicioRead,
  servicioUpdate,
  servicioDelete,  
} = actions;

const servicioListAction = (origen, paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/servicio/list.php?origen=' + origen + '&paramBusqueda=' + paramBusqueda);
      if (response.status === 200 && response.data.data) { 
        
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre };
        });

        dispatch(servicioListSelectBox(registrosList));
        dispatch(servicioList(response.data.data));
        return
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const servicioCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/servicio/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const servicioReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/servicio/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(servicioRead(response.data.data));
          return true;
        }
      } else {
        dispatch(servicioRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

//servicioListSelectBox

;
/////////////////

export {
  servicioListAction,
  servicioCreateAction,
  servicioReadAction,  
};
